import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { DealerProgram } from './interfaces/dealer-program';

@Injectable({
  providedIn: 'root'
})
export class DealerProgramService {

  private endpoint: string = `${this.apiSvc.endpoints.catalog}/api/CatalogImportDealerProgram`;

  constructor(
    private apiSvc: ApiService,
  ) { }

  search(params: object){
    return this.apiSvc.search(this.endpoint, params);
  }

  get(id: number) {
    return this.apiSvc.get(`${this.endpoint}/${id}`);
  }

  update(id: number, payload: DealerProgram) {
    return this.apiSvc.update(`${this.endpoint}/${id}`, payload);
  }
}
